import { render, staticRenderFns } from "./ServiceCreateCommentMediaItem.vue?vue&type=template&id=4099f110&scoped=true"
import script from "./ServiceCreateCommentMediaItem.vue?vue&type=script&lang=ts"
export * from "./ServiceCreateCommentMediaItem.vue?vue&type=script&lang=ts"
import style0 from "./ServiceCreateCommentMediaItem.vue?vue&type=style&index=0&id=4099f110&prod&scoped=true&lang=scss"
import style1 from "./ServiceCreateCommentMediaItem.vue?vue&type=style&index=1&id=4099f110&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4099f110",
  null
  
)

export default component.exports